import {PersonLogin} from '../person/person-login';
import {EntityKey} from '../entity/entity-key';

export class LineResequenceInput {
  entityKey!: EntityKey;
  oldIndex!: number;
  newIndex!: number;
  updateUser!: PersonLogin;
}
